<div class="zwi-embed-container" [innerHTML]="sanitizedIframeURL"></div>
